import { render, staticRenderFns } from "./my-profile.vue?vue&type=template&id=0d0880bc&scoped=true&"
import script from "./my-profile.vue?vue&type=script&lang=js&"
export * from "./my-profile.vue?vue&type=script&lang=js&"
import style0 from "./my-profile.vue?vue&type=style&index=0&id=0d0880bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0880bc",
  null
  
)

export default component.exports